import Axios from "axios";
import { BACK_URL } from "./backendURL"

export const API = Axios.create({
    baseURL: BACK_URL,
    withCredentials: true,
})